import {
  Dialog as MUIDialog,
  DialogActions as MUIDialogActions,
  DialogContent as MUIDialogContent,
  DialogContentText as MUIDialogContentText,
  DialogTitle as MUIDialogTitle,
  type DialogActionsProps,
  type DialogContentProps,
  type DialogContentTextProps,
  type DialogProps,
  type DialogTitleProps,
} from '@mui/material';

import { EventType } from '@/lib/types';

export {
  type DialogActionsProps,
  type DialogContentProps,
  type DialogContentTextProps,
  type DialogTitleProps,
};

export interface TrackedDialogProps extends Omit<DialogProps, 'PaperProps'> {
  trackOpen?: (event: any) => void;
  trackClose?: (event: any) => void;
  trackEventName?: string;
  eventType?: EventType;
  PaperProps?: any;
}

export function Dialog({
  trackOpen,
  trackClose,
  trackEventName,
  eventType = EventType.DIALOG_INTERACTION,
  open,
  onClose,
  PaperProps,
  slotProps,
  ...props
}: TrackedDialogProps) {
  if (open && trackOpen && trackEventName) {
    trackOpen({
      name: trackEventName,
      properties: {
        eventType,
        action: 'Opened',
      },
    });
  }

  const handleClose: DialogProps['onClose'] = (event, reason) => {
    if (trackClose && trackEventName) {
      trackClose({
        name: trackEventName,
        properties: {
          eventType,
          action: 'Closed',
          closeReason: reason,
        },
      });
    }
    if (onClose) {
      onClose(event, reason);
    }
  };

  const mergedSlotProps = {
    ...(slotProps as Record<string, any> | undefined),
    ...(PaperProps
      ? {
          paper: {
            ...PaperProps,
            ...((slotProps as Record<string, any> | undefined)?.paper as
              | Record<string, any>
              | undefined),
          },
        }
      : {}),
  };

  return (
    <MUIDialog
      open={open}
      onClose={handleClose}
      slotProps={mergedSlotProps}
      {...props}
    />
  );
}

export function DialogTitle(props: DialogTitleProps) {
  return <MUIDialogTitle {...props} />;
}

export function DialogContent(props: DialogContentProps) {
  return <MUIDialogContent {...props} />;
}

export function DialogContentText(props: DialogContentTextProps) {
  return <MUIDialogContentText {...props} />;
}

export function DialogActions(props: DialogActionsProps) {
  return <MUIDialogActions {...props} />;
}
